<template>
  <div class="moderator-candidate-resumes-filter">
    <button @click.prevent="$vModal.close()"
            class="moderator-candidate-resumes-filter__close">
      <BaseSvg name="ico-close"/>
    </button>

    <h4 class="moderator-candidate-resumes-filter__title">
      {{ $tModeratorCandidates('Filter') }}
    </h4>

    <div class="moderator-candidate-resumes-filter__list">
      <div v-for="option in options"
           :key="option.value"
           class="moderator-candidate-resumes-filter__item">
        <BaseCheckbox :label="$tModeratorCandidates('filter_' + option.text)"
                      :checked="getValue(option.value)"
                      @input="setValue(option.value, $event)"
                      class="moderator-candidate-resumes-filter__item-checkbox"/>
      </div>
    </div>
  </div>
</template>

<script>
  const options = [{
    text: 'passport_uploaded',
    value: 'passport_uploaded'
  }, {
    text: 'questionnaire_status_end',
    value: 'questionnaire_status_end'
  }, {
    text: 'have_interaction',
    value: 'have_interaction'
  }, {
    text: 'nothave_interaction',
    value: 'nothave_interaction'
  }, {
    text: 'have_sent',
    value: 'have_sent'
  }, {
    text: 'nothave_sent',
    value: 'nothave_sent'
  }, {
    text: 'checked_passport',
    value: 'checked_passport'
  }, {
    text: 'notchecked_passport',
    value: 'notchecked_passport'
  }, {
    text: 'questionnaire_status_on_reload',
    value: 'questionnaire_status_on_reload'
  }]

  export default {
    name: 'AMCandidatesResumesPageActionsFilterModal',
    data() {
      return {
        options
      }
    },
    computed: {},
    methods: {
      getValue(key) {
        const value = this.$route.query[key]
        return (value && value.toString() === 'true') || false
      },

      setValue(key, value) {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }

        delete query['page']

        this.$router.push({
          query
        }).catch(() => ({}))
      }
    }
  }
</script>

<style lang="less">

</style>
